import { createSlice } from '@reduxjs/toolkit'

import { fetchApplicationByHash } from 'apps/applicationInstallation/actions/applicationInstallationActions'
import { InstalledApplication } from 'shared/api/common/schemas/applications'

const initialState: {
  application: InstalledApplication | null
  isFetching: boolean
  applicationIdOrHash: string
} = {
  application: null,
  isFetching: false,
  applicationIdOrHash: '',
}

export const accountsSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchApplicationByHash.pending, (state, action) => {
      state.isFetching = true

      const hash = action?.meta?.arg
      if (hash) {
        state.application = null
        state.applicationIdOrHash = hash
      }
    })

    builder.addCase(fetchApplicationByHash.fulfilled, (state, action) => {
      state.isFetching = false

      const hasPayload = Boolean(action?.payload)

      if (!hasPayload) {
        return
      }

      const { app, hasSettings } = action.payload

      app.hasSettings = hasSettings

      state.application = app
    })
  },
})

export const { reducer } = accountsSlice
